module.exports = __webpack_public_path__ + "img/tmb.cfd387e9.png";